import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { CancelLicenceAutoRenewal, CancelLicenceAutoRenewalVariables } from "./__generated__/CancelLicenceAutoRenewal";
import { CORE_LICENCE_FIELDS } from "../fragments/Licence";

const CANCEL_LICENCE_AUTO_RENEWAL = gql`
  ${CORE_LICENCE_FIELDS}
  mutation CancelLicenceAutoRenewal($organizationId: String!, $licenceId: String!) {
    cancelLicenceAutoRenewal(input: { organizationId: $organizationId, licenceId: $licenceId }) {
      licence {
        ...CoreLicenceFields
      }
    }
  }
`;

export function useCancelLicenceAutoRenewal() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    CancelLicenceAutoRenewal,
    CancelLicenceAutoRenewalVariables
  >(CANCEL_LICENCE_AUTO_RENEWAL, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
